import { KatBadge } from '@amzn/katal-react';
import React, { useContext } from 'react';
import { CorrespondenceTextEditorConstants } from 'src/constants/ProjectConstants';
import { TranslationContext } from 'src/state/providers/TranslationProvider';
import { CorrespondenceType } from 'src/state/slice/models/CorrespondenceTypes';
import styled from 'styled-components';

export interface IPostBadge {
  correspondenceType: CorrespondenceType;
}
const PostBadgeContainer = styled.div``;

const PostBadge: React.FC<IPostBadge> = ({ correspondenceType }) => {
  const { communicationPageBundle } = useContext(TranslationContext);
  return (
    <PostBadgeContainer>
      {correspondenceType === CorrespondenceType.POST && (
        <KatBadge
          type="danger"
          label={communicationPageBundle.getMessage(
            CorrespondenceTextEditorConstants.BADGE_EXTERNAL_POST,
          )}
        ></KatBadge>
      )}
      {correspondenceType === CorrespondenceType.POST_INTERNAL_ONLY && (
        <KatBadge
          type="info"
          label={communicationPageBundle.getMessage(
            CorrespondenceTextEditorConstants.BADGE_INTERNAL_POST,
          )}
        ></KatBadge>
      )}
      {correspondenceType ===
        CorrespondenceType.ACKNOWLEDGEMENT_TO_EXTERNAL && (
        <KatBadge
          type="tag"
          label={communicationPageBundle.getMessage(
            CorrespondenceTextEditorConstants.BADGE_ACK_TO_EXTERNAL,
          )}
        ></KatBadge>
      )}
      {correspondenceType ===
        CorrespondenceType.ACKNOWLEDGEMENT_TO_INTERNAL && (
        <KatBadge
          type="default"
          label={communicationPageBundle.getMessage(
            CorrespondenceTextEditorConstants.BADGE_ACK_TO_INTERNAL,
          )}
        ></KatBadge>
      )}
    </PostBadgeContainer>
  );
};

export { PostBadge };
